import { getDateTimeFormats } from './get-date-time-formats';

export const DateTimeFormatsAPI = {
  getDateTimeFormats,
};
